import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchMarket } from 'api/apiExchange';

import { minutes, seconds } from './utils';

export const useMarketQuery = (market?: string) => {
  return useQuery({
    queryKey: ['markets', market],
    queryFn: !market
      ? skipToken
      : () => fetchMarket(market).then(data => data[0]),
    staleTime: seconds(30),
    refetchOnWindowFocus: false,
    refetchInterval: minutes(15),
  });
};
